import clsx from 'clsx';

import { FieldHint } from './Hint';
import { Prefix } from './Prefix';
import { Suffix } from './Suffix';
import { Wrapper } from './Wrapper';

import type { FieldVariant } from './types';
import type { ComponentPropsWithRef, ReactNode } from 'react';

import s from './Field.module.css';

type FieldRootProps = ComponentPropsWithRef<'div'> & {
  /** Disabled state for hint color */
  disabled?: boolean;
  /** Make field take full width of its container */
  fullWidth?: boolean;
  /** Helper text displayed below the field */
  hint?: ReactNode;
  /** ID for hint element (for aria-describedby) */
  hintId?: string;
  /** Visual state for hint color */
  variant?: FieldVariant;
};

export const Field = ({
  children,
  className,
  disabled,
  fullWidth,
  hint,
  hintId,
  variant = 'default',
  ...props
}: FieldRootProps) => (
  <div className={clsx(s.container, fullWidth && s['container--fullWidth'], className)} {...props}>
    {children}

    {Boolean(hint) && (
      <FieldHint className={s.hint} disabled={disabled} id={hintId} variant={variant}>
        {hint}
      </FieldHint>
    )}
  </div>
);

Field.Wrapper = Wrapper;
Field.Prefix = Prefix;
Field.Suffix = Suffix;

export { default as fieldStyles } from './Field.module.css';
export { getFieldIconColor } from './getVariantStyles';
export type { FieldSize, FieldVariant } from './types';

export { useFieldId } from './useFieldId';
